import React from 'react';
import { AppSplash } from 'components/common';
import { createRoot } from 'react-dom/client';
import App from './App';
import Main from './Main';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'redux/store';
import { GoogleOAuthProvider } from '@react-oauth/google';
import localforage from 'localforage';
import {APP_VERSION} from "./app_config";
import { register as registerServiceWorker } from './serviceWorkerRegistration';
import './tailwind.css';
import 'simplebar/dist/simplebar.min.css'; // SimpleBar styles (was provided by the removed Falcon theme.min.css)
import 'helpers/toastDedup'; // gộp toast lỗi trùng nội dung (chỉ 1 toast)

// Reload once when a lazy-loaded chunk is missing (stale app after deployment)
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.name === 'ChunkLoadError') {
    const reloadKey = 'chunk_reload_attempted';
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, '1');
      window.location.reload();
    }
  }
});

const container = document.getElementById('main');
const root = createRoot(container);

const CURRENT_VERSION = APP_VERSION;
const SAVED_VERSION = localStorage.getItem('app_version');

const renderApp = () => {
  root.render(
    <Provider store={store}>
      <PersistGate loading={<AppSplash />} persistor={persistor}>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}>
          <Main>
            <App />
          </Main>
        </GoogleOAuthProvider>
      </PersistGate>
    </Provider>
  );
};

// Registered before the version check below because it defers its own work to
// the window `load` event: the reload that an APP_VERSION bump triggers fires
// long before that, so this costs nothing on the upgrade path and still runs
// on every normal start.
registerServiceWorker();

if (SAVED_VERSION !== CURRENT_VERSION) {
  // Preserve auth session across version upgrades — only clear UI/data caches
  localforage.getItem('persist:root').then((stored) => {
    let authBackup = null;
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        // Keep only auth + profile so the user stays signed in
        authBackup = JSON.stringify({ auth: parsed.auth, profile_user: parsed.profile_user });
      } catch (_) {
        // invalid JSON — skip backup
      }
    }
    return localforage.clear().then(() => authBackup);
  }).then((authBackup) => {
    if (authBackup) {
      return localforage.setItem('persist:root', authBackup);
    }
  }).then(() => {
    localStorage.setItem('app_version', CURRENT_VERSION);
    window.location.reload();
  });
} else {
  renderApp();
}